import { GenericApiResponse } from 'interfaces';
import { RoleInputI, RoleListI } from 'interfaces/Role';
import { get, patch, post, remove } from 'services/services.methods';
import { RolesPaths } from 'services/services.paths';

export const GetRoleService = async () => {
  const response = await get<RoleListI[]>(RolesPaths.get);

  return response.data;
};

export const GetRoleSelected = async () => {
  const response = await get<RoleListI[]>(RolesPaths.get);

  return response;
};


export const GetRolesByEmpresa = async (idComapany: string) => {
  const response = await get<RoleListI[]>(
    RolesPaths.getByCompany + `/${idComapany}`
  );

  return response;
};

export const GetRolByIdService = async (id: number) => {
  const url = `${RolesPaths.get}/${id}`;
  const response = await get<GenericApiResponse<RoleListI>>(url);

  return response;
};

export const AddRoleService = async (payload: RoleInputI) => {
  const response = await post<any>(RolesPaths.post, payload);
  
  return response;
};

export const PatchRoleService = async (roleId: number, payload: RoleInputI) => {
  const response = await patch<any>(
    RolesPaths.put + `/${roleId}`, payload
  )
  return response;
};

export const RemoveRoleService = async (id: number) => {
   const response = await remove<any>(RolesPaths.delete + `/${id}`);

   return response;
};
